var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name != 'login')?_c('Headers'):_vm._e(),_c('div',{staticClass:"main-container"},[_c('RouterView',{key:_vm.$route.fullPath})],1),_c('Footers')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }